import { ShareModal } from 'components/Toolkit/ShareModal/ShareModal';
import type { ShareModalProps } from 'components/Toolkit/ShareModal/ShareModal';
import { pushToDataLayer } from 'services/gtmService';
import { useOnUpdateOnly } from 'hooks/UseOnUpdateOnly';

export interface RevealShareModalProps extends ShareModalProps {}

function RevealShareModal({
  isOpen,
  askToClose,
  friendlyUrl,
}: RevealShareModalProps) {
  function handleTracking(name: string) {
    pushToDataLayer({ event: name });
  }

  useOnUpdateOnly(() => {
    if (isOpen) {
      pushToDataLayer({ event: 'share_ad' });
    }
  }, [isOpen]);

  return (
    <ShareModal
      isOpen={isOpen}
      askToClose={askToClose}
      friendlyUrl={friendlyUrl}
      trackingCallback={handleTracking}
    />
  );
}

export { RevealShareModal };
